"use client"

import React from "react"
import { toast as sonnerToast } from "sonner"
import { v4 } from "uuid"
interface ActionButton {
  label: string
  onClick: () => void
}
interface ToastProps {
  id?: string | number
  title?: string
  description?: string
  cancel?: ActionButton
  accept?: ActionButton
  duration?: number
  closeButton?: boolean
  onDismiss?: () => void
}

export function toast(toast: Omit<ToastProps, "id">) {
  const id = v4()
  return sonnerToast(
    <Toast
      id={id}
      title={toast.title}
      description={toast.description}
      accept={toast.accept}
      cancel={toast.cancel}
    />,
    {
      id,
      //   toasterId: id,
      duration: toast.duration || 4000,
      closeButton: toast.closeButton || true,
      onDismiss: toast.onDismiss,
    },
  )
}

/** A fully custom toast that still maintains the animations and interactions. */
function Toast(props: ToastProps) {
  const { title, description, accept, cancel, id } = props

  return (
    <div className="flex flex-col ">
      <div className="flex flex-1 items-center">
        <div className="w-full">
          <p className="text-sm font-medium text-gray-900">{title}</p>
          <p className="mt-1 text-sm text-gray-500">{description}</p>
        </div>
      </div>
      <div className=" w-full flex gap-1 justify-end shrink-0 rounded-md text-sm font-medium focus:ring-2  focus:ring-offset-2 focus:outline-hidden">
        {cancel && (
          <button
            className="rounded bg-secondary px-3 py-1 text-sm font-semibold"
            onClick={() => {
              cancel.onClick()
              sonnerToast.dismiss(id)
            }}
          >
            {cancel.label}
          </button>
        )}
        {accept && (
          <button
            className="rounded bg-primary px-3 py-1 text-sm font-semibold text-white"
            onClick={() => {
              accept.onClick()
              sonnerToast.dismiss(id)
            }}
          >
            {accept.label}
          </button>
        )}
      </div>
    </div>
  )
}

export default function Headless() {
  return (
    <button
      className="relative flex h-10 shrink-0 items-center justify-center gap-2 overflow-hidden rounded-full bg-white px-4 text-sm font-medium shadow transition-all hover:bg-[#FAFAFA] dark:bg-[#161615] dark:hover:bg-[#1A1A19] dark:text-white"
      onClick={() => {
        toast({
          title: "This is a headless toast",
          description:
            "You have full control of styles and jsx, while still having the animations.",
          //   accept: { label: "Accept", onClick: () => {} },
          //   cancel: { label: "Decline", onClick: () => {} },
        })
      }}
    >
      Render toast
    </button>
  )
}
